import type {
    FetchParams,
    Middleware,
    RequestContext,
} from '@precon-tools-suite-by-shared/gino-importer-client';

export default class VueMsalMiddleware implements Middleware {
    constructor(protected resolveToken: () => Promise<string>) {}

    async pre(context: RequestContext): Promise<void | FetchParams> {
        try {
            const accessToken = await this.resolveToken();

            context.init.headers = {
                ...context.init.headers,
                Authorization: `Bearer ${accessToken}`,
            };

            return context;
        } catch (error) {
            console.log('Failed to aquire token for ImportApi', error);
            return;
        }
    }
}
